var errorPrefix = 'B2BACCOUNT_ERR_CD_';
var suffixMandatory = '_MANDATORY';
var suffixInvalid = '_INVALID';
export var formErrorMessages = {
    isRequired: {
        code: "".concat(errorPrefix, "FIELD").concat(suffixMandatory),
        message: 'This entry is required to continue',
    },
    isInvalid: {
        code: "".concat(errorPrefix, "FIELD").concat(suffixInvalid),
        message: 'This entry is invalid. Please enter a valid response',
    },
    nameInvalid: {
        code: "".concat(errorPrefix, "NAME").concat(suffixInvalid),
        message: 'Please enter a valid name',
    },
    firstNameRequired: {
        code: "".concat(errorPrefix, "FIRST_NAME").concat(suffixMandatory),
        message: 'Please provide your first name.',
    },
    lastNameRequired: {
        code: "".concat(errorPrefix, "LAST_NAME").concat(suffixMandatory),
        message: 'Please provide your last name.',
    },
    companyNameRequired: {
        code: "".concat(errorPrefix, "COMPANY_NAME").concat(suffixMandatory),
        message: 'Please provide your company name.',
    },
    nickNameRequired: {
        code: "".concat(errorPrefix, "NICK_NAME").concat(suffixMandatory),
        message: 'Please provide a nick name.',
    },
    phoneRequired: {
        code: "".concat(errorPrefix, "PHONE").concat(suffixMandatory),
        message: 'Please provide your 10 digit phone number.',
    },
    phoneInvalid: {
        code: "".concat(errorPrefix, "PHONE").concat(suffixInvalid),
        message: 'Not a valid phone number. Please enter a valid phone number',
    },
    companyPhoneRequired: {
        code: "".concat(errorPrefix, "PHONE").concat(suffixMandatory),
        message: 'Please provide your company phone.',
    },
    companyPhoneInvalid: {
        code: "".concat(errorPrefix, "PHONE").concat(suffixMandatory),
        message: 'Please provide your 10 digit phone number.',
    },
    altPhoneInvalid: {
        code: "".concat(errorPrefix, "PHONE").concat(suffixMandatory),
        message: 'Please provide a valid 10 digit phone number.',
    },
    emailRequired: {
        code: "".concat(errorPrefix, "EMAIL").concat(suffixMandatory),
        message: 'Please enter your email, formatted as you@domain.com.',
    },
    emailInvalid: {
        code: "".concat(errorPrefix, "EMAIL").concat(suffixInvalid),
        message: 'Please provide your email address, formatted as you@domain.com.',
    },
    passwordRequired: {
        code: "".concat(errorPrefix, "PASSWORD").concat(suffixMandatory),
        message: 'Please provide your password.',
    },
    confirmPasswordRequired: {
        code: "".concat(errorPrefix, "PASSWORD").concat(suffixMandatory),
        message: 'Please confirm your password.',
    },
    passwordInvalid: {
        code: "".concat(errorPrefix, "PASSWORD").concat(suffixInvalid),
        message: 'Not a valid password. Please enter a valid password',
    },
    passwordContainsEmail: {
        code: "".concat(errorPrefix, "PASSWORD_HAS_EMAIL"),
        message: 'The password contains your email, this is not secure, please change it',
    },
    confirmPassMatchesPrimary: {
        code: "".concat(errorPrefix, "PASSWORD_CONFIRM_DOESNT_MATCH"),
        message: "These passwords don't match. Please try re-entering your password.",
    },
    passMatchesCommonWord: {
        code: "".concat(errorPrefix, "PASSWORD_IS_COMMON"),
        message: 'Your password is too common, please change it',
    },
    addressRequired: {
        code: "".concat(errorPrefix, "ADDRESS").concat(suffixMandatory),
        message: 'Please provide your address',
    },
    addressInvalid: {
        code: "".concat(errorPrefix, "ADDRESS").concat(suffixMandatory),
        message: 'Not a valid address. Please select or create a new address.',
    },
    cardAddressInvalid: {
        code: "".concat(errorPrefix, "ADDRESS").concat(suffixMandatory),
        message: 'Only use A-Z, 0-9, or single spaces.',
    },
    companyAddressRequired: {
        code: "".concat(errorPrefix, "ADDRESS").concat(suffixMandatory),
        message: 'Please provide your company address.',
    },
    companyAddressInvalid: {
        code: "".concat(errorPrefix, "ADDRESS").concat(suffixMandatory),
        message: 'Not a valid address. Please provide valid company address.',
    },
    companyPOBoxInvalid: {
        code: "".concat(errorPrefix, "ADDRESS").concat(suffixMandatory),
        message: 'PO Boxes are not allowed as a shipping address.',
    },
    zipCodeRequired: {
        code: "".concat(errorPrefix, "ZIPCODE").concat(suffixMandatory),
        message: 'Please provide your 5-digit ZIP Code.',
    },
    zipCodeInvalid: {
        code: "".concat(errorPrefix, "ZIPCODE").concat(suffixInvalid),
        message: 'ZIP Code must be 5 digits.',
    },
    listNameExists: {
        code: "".concat(errorPrefix, "007"),
        message: 'You already have a list with that name. Please enter a different name.',
    },
    listNameMaxLength: {
        code: "".concat(errorPrefix, "131"),
        message: 'You have entered more than 50 characters. Please enter a different name.',
    },
    invalidCharacter: {
        code: "".concat(errorPrefix, "006"),
        // eslint-disable-next-line no-useless-escape
        message: "You have entered an invalid character. Only a-z, 0-9, ! @ # $ % ^ & * ( ) - _ + = , . ? \" '  [ ] { } | : are allowed. Please try again.",
    },
    invalidCompanyName: {
        code: "".concat(errorPrefix, "006"),
        message: "\n    You have entered an invalid character. Only a-z,0-9,&.*#().;@/\u2019 are allowed. Please try again.\n    ",
    },
    listNameRequired: {
        code: "".concat(errorPrefix, "132"),
        message: 'Please enter a name for your list',
    },
    listNoneFound: {
        code: "".concat(errorPrefix, "124"),
        message: 'Sorry, no search results were found',
    },
    listEmptyListOfLists: {
        code: "".concat(errorPrefix, "100"),
        message: 'Sorry, you have no lists to show',
    },
    listDetailsRequired: {
        code: "".concat(errorPrefix, "105"),
        message: 'please enter list details',
    },
    listNoPublicLists: {
        code: "".concat(errorPrefix, "130"),
        message: 'sorry, you don\t have access to any lists',
    },
    emailNameRequired: {
        code: "".concat(errorPrefix, "EMAIL_NAME").concat(suffixMandatory),
        message: 'Please enter your name',
    },
    emailMessageRequired: {
        code: "".concat(errorPrefix, "EMAIL_MESSAGE").concat(suffixMandatory),
        message: 'Please enter your message',
    },
    emailRecipientRequired: {
        code: "".concat(errorPrefix, "EMAIL_RECIPIENT").concat(suffixMandatory),
        message: "Please enter the recipient's email",
    },
    emailFormatInvalid: {
        code: "".concat(errorPrefix, "EMAIL_FORMAT").concat(suffixMandatory),
        message: 'Email format is invalid. Please enter a valid email address',
    },
    // Credit Card - Start
    cardNameRequired: {
        code: "".concat(errorPrefix).concat(suffixMandatory),
        message: 'Please provide the name on the card.',
    },
    cardNumberRequired: {
        code: "".concat(errorPrefix).concat(suffixMandatory),
        message: 'Please provide a card number',
    },
    cardTypeRequired: {
        code: "".concat(errorPrefix).concat(suffixMandatory),
        message: 'Please select a card type',
    },
    cardNumberInvalid: {
        code: "".concat(errorPrefix).concat(suffixMandatory),
        message: "That doesn't seem to be a valid card number. Please try re-entering the number.",
    },
    cardCvvRequired: {
        code: "".concat(errorPrefix).concat(suffixMandatory),
        message: 'Please provide your CVV.',
    },
    validBuyerIdRequired: {
        code: "".concat(errorPrefix).concat(suffixMandatory),
        message: 'Please submit a valid Buyer ID.',
    },
    // Credit Card - End
    // Tax ExemptID - Start
    taxExemptIdRequired: {
        code: "".concat(errorPrefix, "ADDRESS").concat(suffixMandatory),
        message: 'Please provide your Tax Exempt ID.',
    },
    taxExemptIdInvalid: {
        code: "".concat(errorPrefix, "ADDRESS").concat(suffixMandatory),
        message: 'Please enter your 6-10 digit ID.',
    },
    // Tax ExempID - End
    // AgreementCode  - Start
    agreementCodeInvalid: {
        code: "".concat(errorPrefix).concat(suffixMandatory),
        message: "We're sorry. We can't verify that Agreement Code. Please modify your Agreement Code.",
    },
    agreementCodeRequired: {
        code: "".concat(errorPrefix).concat(suffixMandatory),
        message: "Please enter your Agreement code.",
    },
    agreementPricingCodeRequired: {
        code: "".concat(errorPrefix).concat(suffixMandatory),
        message: 'Please enter a valid Agreement Code.',
    },
    agreementPricingCodeInvalid: {
        code: "".concat(errorPrefix).concat(suffixMandatory),
        message: "We're sorry. There has been a temporary technical error. Please try again shortly.",
    },
    // AgreementCode  - End
    // EIN - Start
    einInvalid: {
        code: "".concat(errorPrefix).concat(suffixMandatory),
        message: "Please provide Valid Tax Payer ID / EIN.",
    },
    einRequired: {
        code: "".concat(errorPrefix).concat(suffixMandatory),
        message: "Please provide your Tax Payer ID / EIN. We require Tax Payer ID / EIN when using an Agreement Code.",
    },
    eINPricingInvalid: {
        code: "".concat(errorPrefix).concat(suffixMandatory),
        message: "Please enter your 9 digit EIN.",
    },
    eINPricingRequired: {
        code: "".concat(errorPrefix).concat(suffixMandatory),
        message: "Please enter your 9 digit EIN.",
    },
    // EIN - End
    // Account Number - Start
    accountNumberInvalid: {
        code: "".concat(errorPrefix, "ACCOUNT").concat(suffixMandatory),
        message: "That doesn't seem to be a valid Account Number. Please try re-entering the number.",
    },
    accountNumberRequired: {
        code: "".concat(errorPrefix, "ACCOUNT").concat(suffixMandatory),
        message: "Please provide your account number.",
    },
    // Account Number - End
    // Routing Number - Start
    routingNumberRequired: {
        code: "".concat(errorPrefix, "ACCOUNT").concat(suffixMandatory),
        message: "Please provide your routing number.",
    },
    routingNumberInvalid: {
        code: "".concat(errorPrefix, "ACCOUNT").concat(suffixMandatory),
        message: "That doesn't seem to be a valid ABA/Routing Number. Please try re-entering the number.",
    },
    // Routing Number - End
    // Find a List - Start
    findListFirstNameRequired: {
        code: "".concat(errorPrefix, "FIND_LIST_FIRST_NAME").concat(suffixMandatory),
        message: 'Please enter a first name',
    },
    findListLastNameRequired: {
        code: "".concat(errorPrefix, "FIND_LIST_LAST_NAME").concat(suffixMandatory),
        message: 'Please enter a last name',
    },
    findListEmailRequired: {
        code: "".concat(errorPrefix, "FIND_LIST_EMAIL").concat(suffixMandatory),
        message: 'Please enter an email address',
    },
    cardCVVRequired: {
        code: "".concat(errorPrefix).concat(suffixMandatory),
        message: 'Please provide a card CVV',
    },
    cardCVVValid: {
        code: "".concat(errorPrefix).concat(suffixMandatory),
        message: 'CVV must be {digit} digits.',
    },
    // Find a List - End
    // Keytag Number - Start
    keyTagRequired: {
        code: "".concat(errorPrefix, "KEYTAG").concat(suffixMandatory),
        message: "Please provide your Keytag number.",
    },
    keyTagInvalid: {
        code: "".concat(errorPrefix, "KEYTAG").concat(suffixMandatory),
        message: "That doesn't seem to be a valid Keytag Number. Please try re-entering the number.",
    },
    // Keytag Number - End
};
